export default {
  app: {
    title: "Boîte de vocabulaire de rêve",
    language: "Français"
  },

  pages: {
    app: {
      myAccount: "Mon compte",
      editProfile: "Modifier le profil",

      boxScenarios: "Scénarios des boîtes",
      scenario1Title: "Boîte demi-journée",
      scenario1Desc: "Révisez la boîte toutes les demi-journées (par exemple matin et soir).",

      scenario2Title: "Boîte quotidienne",
      scenario2Desc: "Révisez la boîte une fois par jour.",

      scenario3Title: "Jours selon le numéro de boîte",
      scenario3Desc: "Révisez la boîte selon son numéro (par exemple, la boîte 3 tous les 3 jours).",

      username: "Nom d'utilisateur",
      usernameHint: "Votre nom d'utilisateur unique pour vous connecter",

      name: "Nom",
      nameHint: "Comment devons-nous vous appeler ?",

      email: "Adresse e-mail",
      emailHint: "E-mail pour la récupération du mot de passe (optionnel)",

      changePassword: "Changer le mot de passe",
      changePasswordHint: "Si vous ne souhaitez pas changer le mot de passe, laissez ce champ vide (optionnel)",

      logout: "Se déconnecter",
      confirmLogout: "Confirmer la déconnexion",
      confirmLogoutText: "Êtes-vous sûr de vouloir vous déconnecter ?",
      cancel: "Annuler",

      close: "Fermer",
      updateProfile: "Mettre à jour le profil",

      myWords: "Mes mots",
      addNewWord: "Ajouter un nouveau mot / idiome",
      boxes: "Boîtes",

      applicationSettings: "Paramètres de l'application",

      autoSpeechOnChecking: "Lire automatiquement le mot lorsqu'il commence à s'afficher",
      autoDetectClipboardChange: "Détecter automatiquement le texte du presse-papiers",

      clipboardPermissionText: "L'application a besoin d'une autorisation pour accéder au presse-papiers dans les paramètres du navigateur. Pour plus d'aide, cliquez ici.",

      clipboardHelpTitle: "Comment activer l'accès au presse-papiers",

      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",

      chromeStep1: "Ouvrez le navigateur Chrome.",
      chromeStep2: "Accédez aux paramètres du navigateur.",
      chromeStep3: "Trouvez la section Paramètres du site ou Paramètres.",
      chromeStep4: "Allez dans Autorisations et activez le presse-papiers.",

      firefoxStep1: "Ouvrez le navigateur Firefox.",
      firefoxStep2: "Accédez aux paramètres du navigateur.",
      firefoxStep3: "Trouvez la section Autorisations et activez l'accès au presse-papiers.",

      safariStep1: "Ouvrez l'application Réglages de votre téléphone.",
      safariStep2: "Accédez à Safari.",
      safariStep3: "Recherchez les paramètres liés au presse-papiers et activez-les.",

      otherBrowserTitle: "Si vous utilisez un autre navigateur",
      otherBrowserStep1: "Recherchez une option similaire dans Autorisations ou Paramètres du site dans les paramètres du navigateur et activez l'accès au presse-papiers.",

      speechNotSupported: "Votre navigateur ne prend pas en charge SpeechSynthesis",

      ttsSettings: "Paramètres de synthèse vocale",
      sampleText: "Texte pour tester la voix",

      rate: "Vitesse",
      rateHint: "Contrôle la vitesse de la parole.",

      pitch: "Hauteur",
      pitchHint: "Ajuste la hauteur de la voix.",

      volume: "Volume",
      volumeHint: "Règle le volume de la parole.",

      friends: "Amis",
      messages: "Messages",

      addToMyWords: "Ajouter {word} à mes mots",
      viewInMyList: "Voir {word} dans ma liste",

      wordSuggestion: "Suggestion de mot",
      goToAddWord: "Aller à l'ajout d'un nouveau mot",

      updateCompleted: "Mise à jour effectuée avec succès",
      latestChanges: "Derniers changements des versions récentes",
      version: "Version",
      gotIt: "Compris"
    },

    addVocabulary: {
      title: "Ajouter un nouveau mot",
      add: "Ajouter",
      word: "Mot / Expression",
      meaning: "Signification",
      example: "Exemple",
      description: "Description"
    },

    vocabularies: {
      searchLabel: "Rechercher un texte",
      listLength: "Longueur de la liste",
      boxNumber: "Numéro de boîte",
      nothingFound: "Aucun résultat trouvé !!!",
      adjustFilters: "Veuillez essayer d'ajuster vos filtres",
      tableWord: "Mot",
      tableAction: "Action",
      showDetails: "Afficher les détails",
      completeInfo: "Informations complètes",
      meaning: "Signification",
      example: "Exemple",
      description: "Description",
      close: "Fermer",
      editTitle: "Modifier",
      editBtn: "Modifier",
      deleteTitle: "Supprimer {word}",
      deleteConfirmText: "Êtes-vous sûr de vouloir supprimer ce vocabulaire ? Veuillez noter qu'une fois supprimé, il ne pourra pas être restauré.",
      yes: "Oui !",
      no: "Non"
    },

    messages: {
      wordSuggestions: "Suggestions de mots"
    },

    login: {
      signInTitle: "Connexion",
      signInBtn: "Se connecter",
      registerTitle: "Inscription",
      registerBtn: "S'inscrire",
      registerLink: "S'inscrire",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      nickname: "Nom",
      email: "Adresse e-mail",
      noAccount: "Vous n'êtes pas encore inscrit ?",
      haveAccount: "J'ai déjà un compte.",
      usernameHint: "Votre nom d'utilisateur unique pour vous connecter",
      nicknameHint: "Comment devons-nous vous appeler ?",
      emailHint: "E-mail pour la récupération du mot de passe (optionnel)",
      passwordHint: "Mot de passe sans règles, saisissez ce que vous voulez",
      orContinueWith: "Ou continuer avec...",
      guestRegister: "Inscription rapide en tant qu'invité 😒"
    },

    reviewVocabulary: {
      showMeaning: "Afficher la signification",
      hideMeaning: "Masquer la signification",
      meaning: "Signification",
      example: "Exemple",
      description: "Description",
      playPhrase: "PlayPhrase.me",
      prev: "Préc.",
      next: "Suiv."
    },

    checkVocabulary: {
      showMeaning: "Afficher la signification",
      hideMeaning: "Masquer la signification",
      wordsRemain: "Mots restants",
      lastOne: "Dernier",
      meaning: "Signification",
      example: "Exemple",
      description: "Description",
      playPhrase: "PlayPhrase.me",
      iRemember: "Je m'en souviens",
      iDontRemember: "Je ne m'en souviens pas"
    },

    boxes: {
      all: "Afficher toutes les boîtes",
      box: "Boîte",
      empty: "Vide",
      needsChecking: "À vérifier",
      checked: "Vérifié",

      total: "Total",
      waiting: "En attente",
      waitingForCheck: "En attente de vérification",

      closestReview: "Prochaine révision",
      notScheduled: "Pas encore planifié",

      deeplyMemorized: "Vous avez parfaitement mémorisé {count} mots.",
      notReachedYet: "Oups ! Vous n'avez pas encore atteint cette boîte.",

      startChecking: "Commencer la vérification",
      review: "Réviser",
      viewAllWords: "Voir tous les mots",
      addNew: "Ajouter",
      itsEmpty: "C'est vide"
    },

    friends: {
      searchInUsers: "Rechercher parmi les utilisateurs",
      searchList: "Liste de recherche",
      noUsersYet: "Il n'y a pas encore d'utilisateurs.",
      searchUsersAndSendRequest: "Vous pouvez rechercher des utilisateurs et envoyer une demande d'ami",
      friendList: "Liste d'amis",
      noFriendsYet: "Il n'y a pas encore d'amis."
    }
  },

  plugins: {
    axios: {
      postRequestError: "Une erreur s'est produite lors de l'envoi de la requête"
    }
  },

  components: {
    shareButton: {
      shareTitle: "Partager {word}",
      messageOptional: "Message (optionnel)"
    },

    userList: {
      cancelRequest: "Annuler la demande",
      unfriend: "Retirer des amis",
      sendRequest: "Envoyer une demande",
      accept: "Accepter",
      reject: "Refuser",

      share: "Partager",
      addedBefore: "Déjà ajouté auparavant",

      deeplyMemorized: "{name} a parfaitement mémorisé {count} mots.",
      notReachedBox: "{name} n'a pas encore atteint cette boîte.",

      totalVocabularies: "Nombre total de vocabulaires",
      registerAge: "Ancienneté d'inscription",
      lastCheck: "Dernière vérification",
      lastAddedVocabulary: "Dernier vocabulaire ajouté",
      totalChecks: "Nombre total de vérifications",
      averageDailyCheck: "Moyenne quotidienne des vérifications",
      averageDailyLearnedCheck: "Moyenne quotidienne des vérifications apprises",
      averageDailyNotLearnedCheck: "Moyenne quotidienne des vérifications non apprises",
      averageDailyAdd: "Moyenne quotidienne des ajouts"
    }
  },

  public: {
    close: "Fermer"
  },
  "apiResultStatusCodes": {
    "0": "Échec de l'opération",
    "1": "Opération réussie",
    "2": "Une erreur est survenue",
    "3": "Paramètres envoyés invalides",
    "4": "Introuvable",
    "5": "Erreur d'authentification",
    "6": "Cet élément est déjà enregistré",
    "7": "Cet utilisateur est déjà enregistré",
    "8": "L'utilisateur spécifié n'existe pas",
    "9": "Mot de passe incorrect",
    "10": "Paramètres invalides",
    "11": "Échec de la connexion",
    "12": "Accès refusé",
    "13": "Élément introuvable",
    "14": "Ce nom d'utilisateur est déjà utilisé",
    "15": "Cet email est déjà utilisé",
    "16": "Le nom d'utilisateur est requis",
    "17": "Le pseudonyme est requis",
    "18": "Le mot de passe est requis",
    "19": "Le nom d'utilisateur ne peut pas contenir d'espaces",
    "20": "Inscription réussie",
    "21": "Connexion réussie",
    "22": "Le mot de passe ne peut pas contenir d'espaces",
    "23": "Vocabulaire ajouté avec succès",
    "24": "Vocabulaire mis à jour avec succès",
    "25": "Vocabulaire supprimé avec succès",
    "26": "Vous avez déjà ajouté ce vocabulaire",
    "27": "Le mot est requis",
    "28": "Aucun vocabulaire trouvé",
    "29": "Félicitations ! Tous les mots de cette boîte ont été vérifiés",
    "30": "Vous ne pouvez pas modifier le champ du mot",
    "31": "Veuillez remplir les champs obligatoires",
    "32": "Aucune modification détectée",
    "33": "L'utilisateur spécifié n'existe pas dans le dépôt",
    "34": "Demande d'ami envoyée avec succès",
    "35": "Demande d'ami acceptée avec succès",
    "36": "Demande d'ami annulée avec succès",
    "37": "Amitié supprimée avec succès",
    "38": "Demande rejetée avec succès",
    "39": "Message envoyé avec succès"
  },
  "time": {
    "day": "jour | jours",
    "hour": "heure | heures",
    "minute": "minute | minutes"
  }

}
